/* Djurslottet - hjalpskript till header-soket.

   2026-08-23: RENDERINGEN AV KOLLEKTIONER FLYTTADES HARIFRAN.
   Sokrutan visar numera fyra grupper - produkter, kollektioner, sidor och blogg - och allt
   det byggs i sections/dj-search.liquid, i EN request mot /search/suggest.json och med en
   gemensam relevansordning. Skulle den har filen ocksa rita kollektioner skulle de dyka upp
   TVA ganger, sa den koden ar borttagen.

   Kvar finns bara en sak som fortfarande behovs: CHATTBUBBLAN.
   Appen shopify-chat lag over sokforslagen pa mobil och satter egna INLINE-stilar, sa vanlig
   CSS forlorar. Darfor satts opacity/pointer-events inline med !important medan panelen ar
   oppen, och tas bort igen nar den stangs. (Elementet heter shopify-chat i den har butiken,
   inte inbox-online-store-chat - bada matchas for sakerhets skull.)

   Soksektionen skickar dj:search-state nar panelen oppnas eller stangs. En liten observer
   pa body-nivaens direkta barn fangar bara en sent inladdad eller ersatt chatthost, utan
   aterkommande timer och utan att observera hela dokumentets undertrad.

   Antal produkter per kollektion ligger kvar i [data-dj-cols-config] som sections/
   dj-search-collections.liquid skriver ut. Den kartan LASES numera av dj-search.liquid
   (chippet "Kollektion - 238 produkter"). Ta inte bort den. */
(function () {
  window.__djSearchChat = 'loaded';

  var hideChat = true;
  var readCfg = false;

  function wantHide() {
    if (readCfg) return hideChat;
    var el = document.querySelector('[data-dj-cols-config]');
    if (!el) return hideChat;              /* sektionen kan komma senare i header-gruppen */
    try {
      var j = JSON.parse(el.textContent || '{}');
      if (typeof j.hideChat === 'boolean') hideChat = j.hideChat;
    } catch (e) {}
    readCfg = true;
    return hideChat;
  }

  function isOpen() {
    var p = document.querySelector('.dj-hsearch__panel');
    return !!(p && p.classList.contains('is-open'));
  }

  function chat(hide) {
    if (!wantHide()) return;
    document.documentElement.classList.toggle('dj-search-open', !!hide);
    var els = document.querySelectorAll('shopify-chat, inbox-online-store-chat');
    for (var i = 0; i < els.length; i++) {
      if (hide) {
        els[i].style.setProperty('opacity', '0', 'important');
        els[i].style.setProperty('pointer-events', 'none', 'important');
      } else {
        els[i].style.removeProperty('opacity');
        els[i].style.removeProperty('pointer-events');
      }
    }
  }

  var wasOpen = isOpen();

  function update(open) {
    open = !!open;
    if (open === wasOpen) return;
    wasOpen = open;
    chat(open);
  }

  document.addEventListener('dj:search-state', function (event) {
    update(!!(event.detail && event.detail.open));
  });

  // If the app inserts or replaces its top-level host while search is open,
  // apply the current state once. No recurring timer is needed.
  if (document.body) {
    new MutationObserver(function (mutations) {
      if (!wasOpen) return;
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches('shopify-chat, inbox-online-store-chat') ||
              node.querySelector('shopify-chat, inbox-online-store-chat')) {
            chat(true);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: false });
  }

  chat(wasOpen);
})();
